import Joi from "joi";
import { parseNumericValue } from "../../../utils/common";
import { logger } from "../../../utils/logger";

export const createNomineeAndBankDetailsSchema = Joi.object({
  name: Joi.string()
    .min(3)
    .max(255)
    .required()
    .messages({
      "string.pattern.base": "Nominee Name is required.",
      "string.base": "Nominee Name is required.",
      "string.empty": "Nominee Name is required.",
      "string.min": "Nominee Name must be at least 3 characters.",
      "string.max": "Nominee Name must not exceed 255 characters.",
      "any.required": "Nominee Name is required.",
    }),

  relationship: Joi.string()
    .valid(
      // "Spouse",
      // "Child",
      // "Parent",
      // "Sibling",
      // "Grandparent",
      // "Grandchild",
      // "Guardian",
      // "Relative",
      // "Friend"
      "Father",
      "Mother",
      "Son",
      "Daughter",
      "Spouse"
    )
    .required()
    .messages({
      "any.only": "Invalid Nominee Relation. Please select a valid option.",
      "string.empty": "Nominee Relation is required.",
      "string.pattern.base": "Nominee Name is required.",
      "string.base": "Nominee Relation is required.",
      "any.required": "Nominee Name is required.",

    }),

  date_of_birth: Joi.date()
    .required()
    .messages({
      "date.base": "Date of Birth must be a valid date.",
      "any.required": "Date of Birth is required.",
    }),

  contact_no: Joi.string()
    .pattern(/^[6-9]\d{9}$/)
    .required()
    .messages({
      "string.pattern.base": "Invalid Contact Number format. Must start with 6-9 and contain 10 digits.",
      "string.empty": "Contact Number is required.",
      "string.base": "Contact Number is required.",
      "any.required": "Contact Number is required.",

    }),

  address: Joi.string()
    .max(500)
    .allow("")
    .messages({
      "string.max": "Address must not exceed 500 characters.",

    }),

  percentage_of_benefit: Joi.number()
    .min(0)
    .max(100)
    .required()
    .messages({
      "number.base": "Percentage of Benefits must be a number.",
      "number.min": "Percentage of Benefits must be at least 0%.",
      "number.max": "Percentage of Benefits must not exceed 100%.",
      "any.required": "Percentage of Benefits is required.",
    })
    .custom((value, helpers) => {
      const { percentageremaingValue, nominee_id, nomineeList } = helpers?.prefs?.context || {};

      logger.log(helpers?.prefs?.context, "helpers?.prefs?.context")

      if (nominee_id) {
        const findpercentageremaingValue = 100 - nomineeList?.nominees?.reduce((prev, curr) => {

          let percentage_of_benefitValue = 0;

          if (curr?.nominee_id !== nominee_id) {
            percentage_of_benefitValue = parseNumericValue(curr?.percentage_of_benefit);
          }
          return prev + percentage_of_benefitValue
        }, 0)
        if (findpercentageremaingValue < value) {
          return helpers.message(
            `Percentage the value must be between 1 and ${findpercentageremaingValue}.`
          );
        }

      } else {
        if (percentageremaingValue === 0) {
          return helpers.message("You have already allocated 100% of benefits.");
        }
        if (percentageremaingValue < value) {
          return helpers.message(
            `Percentage the value must be between 1 and ${percentageremaingValue}.`
          );
        }
      }

      return value;
    }),

  // idProof: Joi.string()
  //   .required()
  //   .messages({
  //     "string.empty": "ID Proof is required.",
  //     "any.required": "ID Proof is required.",

  //   }),

  bank_name: Joi.string()
    .min(2)
    .max(255)
    .allow("")
    .messages({
      "string.min": "Bank Name must be at least 2 characters.",
      "string.max": "Bank Name must not exceed 255 characters.",
    }),

  account_number: Joi.string()
    .pattern(/^\d+$/)
    .min(10)
    .max(18)
    .allow("")
    .messages({
      "string.pattern.base": "Account Number is required.",
      "string.min": "Account Number must be at least 10 digits.",
      "string.max": "Account Number must not exceed 18 digits.",

    }),

  ifcs: Joi.string()
    .pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/)
    .allow("")
    .messages({
      "string.pattern.base": "IFSC Code must be in the format ABCD0XYZ123.",
    }),
});
